import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CustomerServicesInfo } from '../../../../models/customer.model';
import { CustomerInfoService } from '../../../../services/customer/customerinfo.service';

@Component({
  selector: 'app-customer-serviceinfo',
  templateUrl: './serviceinfo.component.html',
  styleUrls: ['./serviceinfo.component.css']
})
export class CustomerDetailServiceInfoComponent implements OnInit {

  @Input() customerId: string;
  newDataAvailable = false;
  listServices: Array<CustomerServicesInfo>;
  listStates: Array<{value: string, label: string}>;
  listStatesBl: Array<{value: string, label: string}>;
  statusFilter: any;
  public showEditServiceModal = false;
  selectedService: CustomerServicesInfo = new CustomerServicesInfo();


  render = {
    datatable: false
  };

  constructor(
    public srvCustomer: CustomerInfoService,
    private translate: TranslateService,
    private router: Router

  ) { }

  ngOnInit(): void {

    this.refresh();

    this.translate.get([
      'common.all',
      'common.status_notDeleted',
      'common.status_onlyDeleted',
      'common.status_onlySuspended',
      'common.status_inattive',
      'loyalty.blacklist'
    ]).subscribe(t => {
      this.listStates = [];
      this.listStates.push({label: t['common.all'], value: ''});
      this.listStates.push({label: t['common.status_notDeleted'], value: '0'});
      this.listStates.push({label: t['common.status_onlyDeleted'], value: '1'});
      this.listStates.push({label: t['common.status_inattive'], value: 'null'});

    });



  }

  refresh() {
    this.listServices = [];
    this.srvCustomer.getAllServices(this.customerId).subscribe(res => {
      if (res) {
        this.listServices = res;
        this.newDataAvailable = true;
      }
    });
  }
  /*reloadList() {
    this.srvCustomer.getAllServices(this.customerId).subscribe( (res) => {
      this.listServices = res;
    });
  }*/

  edit(custServInfo: CustomerServicesInfo) {
    if (custServInfo.customerServiceId == null) {
      custServInfo.customerServiceId = 0;
    }
    // this.router.navigate(['/customer-details/serviceform/' + custServInfo.customerServiceId + ';' + this.customerId + ';' + custServInfo.serviceId]);
    // this.router.navigate(['/customer-details/serviceform/' + custServInfo.customerServiceId]);
    // this.router.navigate(['/customers-summary/']);
    this.selectedService = custServInfo == null ? new CustomerServicesInfo() : custServInfo;
    this.showEditServiceModal = true;

  }

  onRemove(service) {
    if (service.id != null) {
      this.srvCustomer.removeService(service.id).subscribe(() => {
        this.newDataAvailable = true;
      });
    }

  }

  serviceAdded(custServInfo: CustomerServicesInfo) {
    custServInfo.customerId = +this.customerId;
    this.srvCustomer.postService(custServInfo).subscribe(() => {
      this.showEditServiceModal = false;
      this.newDataAvailable = true;
    });
  }

  serviceUpdated(custServInfo: CustomerServicesInfo) {
    // custServInfo.dateStart = custServInfo.dateStart.substring(1,2)
    this.srvCustomer.putService(custServInfo).subscribe(() => {
      this.showEditServiceModal = false;
      this.newDataAvailable = true;
    });
  }

  serviceDeleted(custServInfo: CustomerServicesInfo) {
    this.srvCustomer.DeleteService(custServInfo).subscribe(() => {
      this.showEditServiceModal = false;
      this.newDataAvailable = true;
    });
  }

  serviceAddBlacklist(custServInfo: CustomerServicesInfo) {
    this.srvCustomer.putSetBlacklistService(custServInfo).subscribe(() => {
      this.showEditServiceModal = false;
      this.newDataAvailable = true;
    });
  }

  serviceRecovBlacklist(custServInfo: CustomerServicesInfo) {
    this.srvCustomer.putRecoveryBlacklistService(custServInfo).subscribe(() => {
      this.showEditServiceModal = false;
      this.newDataAvailable = true;
    });
  }

  serviceRecovery(custServInfo: CustomerServicesInfo) {
    this.srvCustomer.putRecoveryService(custServInfo).subscribe(() => {
      this.showEditServiceModal = false;
      this.newDataAvailable = true;
      this.refresh();
    });
  }

  /*onDialogHide() {
    this.srvCustomer.getAllServices(this.customerId).subscribe( (res) => {
      this.listServices = res;
    });
  }*/

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/serviceinfo/serviceinfo.component.ts